import type { HeaderPageBlock_V2 } from "@towni/common";
import { pageBlockViewContextFactory } from "../../../page-block-view-context-factory";

const [Header_PageBlock_Provider_v2, useHeaderPageBlockStore_V2] =
    pageBlockViewContextFactory<HeaderPageBlock_V2>();
export { Header_PageBlock_Provider_v2, useHeaderPageBlockStore_V2 };
